import { Component, OnInit } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-all-user-logins",
	templateUrl: "./manage-all-user-logins.component.html",
	styleUrls: ["./manage-all-user-logins.component.scss"]
})
export class ManageAllUserLoginsComponent implements OnInit {
	public users: APIResults.UserLoginCounts[];

	constructor(public api: ApiService) { }

	async ngOnInit() {
		await this.updateUsers();
	}

	async updateUsers() {
		const result = await this.api.GetUserLogins();
		this.users = result;
	}

	async SortBy(field: string) {
		this.users.sort((a, b) => {
			return b[field] - a[field];
		});
	}
}
